import { Skeleton } from '@crehana/compass.ui/v3/skeleton';
import { MiniHeader } from '@crehana/compass.web/mini-header';
import { WizardLayout } from '@crehana/compass.web/wizard-layout';

import { useNavigate } from '@/shared/modern-router';

import { useAddI18nLocales, useTranslation } from './i18n';

// Route-level fallback shown while the page chunk itself loads (finding
// F-13). Keeps the same header shell the page renders, so the back control
// never disappears. `useCollaboratorComplianceDetail`'s own `loading`
// branch, inside `ComplianceDetailContent`, covers the data-fetch wait once
// the page has mounted.
export const AdminLegalAlertsMexicoColaboradorLoading = () => {
  useAddI18nLocales();
  const { t } = useTranslation();
  const { goBack } = useNavigate();

  return (
    <WizardLayout>
      <WizardLayout.Header>
        <MiniHeader
          title={t('HEADER_TITLE')}
          onBack={goBack}
          backLabel={t('BUTTON_BACK')}
        />
      </WizardLayout.Header>

      <WizardLayout.Body containerSize="lg">
        <div className="tw-flex tw-flex-col tw-cds-gap-6">
          <Skeleton.Block className="tw-h-[6.4rem]" />
          <Skeleton.Block className="tw-h-[12rem]" />
          <Skeleton.Block className="tw-h-[24rem]" />
        </div>
      </WizardLayout.Body>
    </WizardLayout>
  );
};
